/*
 * Get any errors from retrieving the quote (def. to null)
 */
import type { RootState } from '/business/shared/state/store';
import type { PaymentQuote } from '/business/shared/state/reducers/payment';

export default (state: RootState): PaymentQuote | null | undefined => {
  return state.payment?.quote;
};
